import { useMemo } from 'react'
import { useQueryResponse } from '../core/QueryResponseProvider'
import { useQueryRequest } from '../core/QueryRequestProvider'
import { useListFilters } from '../core/ListFiltersProvider'
import { personalAtendimentosColumns } from './columns/_columns'
import { AtendimentoView } from '../../../atendimento/core/_models'
import { CustomTable, TableEmptyState } from '../../../../../components'
import { useT } from '_metronic/i18n/Metronici18n'

export const PersonalAtendimentosTable = () => {
  const { isLoading, isError, refetch, response } = useQueryResponse()
  const { hasFilters, clearFilters } = useListFilters()
  const { t } = useT()
  const columns = useMemo(() => personalAtendimentosColumns(t), [t])

  const emptyState = hasFilters ? (
    <TableEmptyState
      title='Nenhum atendimento encontrado'
      description='Revise os filtros aplicados.'
      action={{ label: 'Limpar filtros', onClick: clearFilters }}
    />
  ) : (
    <TableEmptyState
      title='Nenhum atendimento ainda'
      description='Os atendimentos sob sua responsabilidade aparecem aqui.'
    />
  )

  return (
    <CustomTable<AtendimentoView>
      id='kt_table_meus_atendimentos'
      ariaLabel='Meus atendimentos'
      itemLabel={{ singular: 'atendimento', plural: 'atendimentos' }}
      data={response?.data || []}
      columns={columns}
      isLoading={isLoading}
      isError={isError}
      onRetry={refetch}
      emptyState={emptyState}
      queryHooks={{ useQueryRequest, useQueryResponse }}
    />
  )
}
